import { render, staticRenderFns } from "./ColSalvage.vue?vue&type=template&id=1ddb67a9&scoped=true&"
import script from "./ColSalvage.vue?vue&type=script&lang=js&"
export * from "./ColSalvage.vue?vue&type=script&lang=js&"
import style0 from "./ColSalvage.vue?vue&type=style&index=0&id=1ddb67a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddb67a9",
  null
  
)

export default component.exports